import { Centrifuge } from 'centrifuge';

import { checkAndRefreshToken } from '@/utils/check-and-refresh-token.ts';
import { logEvent } from '@/utils/sentry-monitor.tsx';

const baseWSURL = import.meta.env.VITE_WS_BASE_URL;

const centrifuge = new Centrifuge(baseWSURL, {
  debug: false,
  getToken: async () => {
    const token = await checkAndRefreshToken();
    if (!token) {
      logEvent(`Failed to set new token for Centrifuge`, {}, 'warning', true);
      throw new Error('Centrifuge token is empty');
    }
    return token;
  }
});

export default centrifuge;
